"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AllowSingleOpenAccordion", {
  enumerable: true,
  get: function () {
    return _helpers.AllowSingleOpenAccordion;
  }
});
exports.default = void 0;
var _react = require("react");
var _Icon = _interopRequireDefault(require("../../_nextgen/components/Icon"));
var _styledComponentThemes = _interopRequireDefault(require("../../_nextgen/packages/styled-component-themes"));
var _analytics = _interopRequireWildcard(require("../../components/analytics/"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _IconLibrary = require("../../packages/IconLibrary");
var _redux = require("../../packages/redux");
var _ScrollManager = _interopRequireDefault(require("../../packages/ScrollManager"));
var _helpers = require("./helpers");
var _index = _interopRequireWildcard(require("./index.ducks"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var themes = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const Icons = {
  CaretDown: _IconLibrary.CaretDown,
  CaretUp: _IconLibrary.CaretUp,
  Minus: _IconLibrary.Minus,
  Plus: _IconLibrary.Plus,
  ToyotaCaretDown: _IconLibrary.ToyotaCaretDown,
  ToyotaCaretUp: _IconLibrary.ToyotaCaretUp
};
const CheckIconPath = "/content/dam/lexus/images/models/_global/overlay/legend/Icon_Standard.svg";
const AccordionDrawer = function (_ref) {
  let {
    id = "AccordionDrawer",
    heading = "",
    headingContents,
    headingColor,
    iconColor,
    expandedIcon = "Minus",
    collapsedIcon = "Plus",
    openOnMount,
    children,
    className,
    isDrawerOpen,
    headingClassName,
    label,
    labelClose,
    sticky,
    persist = false,
    onOpen = function () {},
    onClose = function () {},
    showDecorator = false,
    hideHeading = false,
    marginLeft = false,
    showIconWhenOpen = true,
    selectedIcon = false,
    enableScroll = true,
    ariaLabel = ""
  } = _ref;
  const scrollOnOpen = window.location.hash === `#${id}`;
  const [select, dispatch] = (0, _redux.useReducerManager)({
    id,
    reducer: _index.default,
    persist,
    initialState: {
      ..._index.initialState,
      drawerOpen: openOnMount || scrollOnOpen || isDrawerOpen
    }
  });
  const drawerOpen = select(_index.getDrawerOpen);
  const accordionRef = (0, _react.useRef)(null);
  const resizeObserver = (0, _react.useRef)(null);
  const fireAnalytics = (0, _analytics.default)("Accordion", {
    heading
  });
  const [singleOpenAccordionId, setSingleOpenAccordionId] = (0, _helpers.useSingleAccordionOpen)();
  const isSingleOpenDrawer = singleOpenAccordionId === id;
  const hasSingleAccordionOpenBehavior = Boolean(singleOpenAccordionId);
  const shouldBeOpen = hasSingleAccordionOpenBehavior ? isSingleOpenDrawer : drawerOpen;
  // biome-ignore lint/correctness/useExhaustiveDependencies: <we don't need to track the rest of dependencies>
  (0, _react.useEffect)(function () {
    if (!hasSingleAccordionOpenBehavior && typeof isDrawerOpen !== "undefined" && isDrawerOpen !== drawerOpen) {
      dispatch((0, _index.setDrawerOpen)({
        drawerOpen: isDrawerOpen
      }));
    }
  }, [isDrawerOpen]);
  const collapseMenuRef = (0, _react.useCallback)(function (node) {
    if (!node) {
      return;
    }
    resizeObserver.current ??= new ResizeObserver(function () {
      if (Number.parseInt(node.style.maxHeight, 10) + 50 === node.scrollHeight) {
        return;
      }
      node.style.maxHeight = `${node.scrollHeight + 50}px`;
    });
    resizeObserver.current.observe(node);
  }, []);
  const handleExpandDrawer = function () {
    fireAnalytics("expand");
    const accordionElement = accordionRef.current;
    const shouldScroll = enableScroll && !sticky;
    if (accordionElement && shouldScroll) {
      (0, _ScrollManager.default)(accordionElement);
    }
    onOpen();
  };
  const handleButtonClick = function () {
    const updatedDrawerIsOpen = !drawerOpen;
    if (hasSingleAccordionOpenBehavior) {
      if (!isSingleOpenDrawer) {
        setSingleOpenAccordionId(id);
        handleExpandDrawer();
      }
      return;
    }
    dispatch((0, _index.setDrawerOpen)({
      drawerOpen: updatedDrawerIsOpen
    }));
    if (updatedDrawerIsOpen) {
      handleExpandDrawer();
    } else {
      fireAnalytics("collapse");
      onClose();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.AccordionDrawer, {
    id: id,
    className: className,
    $sticky: sticky,
    ref: accordionRef,
    showDecorator: showDecorator && shouldBeOpen,
    "data-testid": "AccordionDrawer",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DrawerButton, {
      type: "button",
      onClick: handleButtonClick,
      "aria-controls": `${id}-control`,
      scope: "column",
      "aria-expanded": shouldBeOpen,
      "aria-label": ariaLabel,
      className: shouldBeOpen ? "drawerOpen" : "drawerClose",
      showDecorator: showDecorator && shouldBeOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DrawerHeading, {
        $headingColor: headingColor,
        className: headingClassName,
        $selectedIcon: selectedIcon,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.HeadingContainer, {
          $hideHeading: shouldBeOpen && hideHeading,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: heading
          }), label && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.AccordionLabelContainer, {
            style: {
              display: "flex",
              justifyContent: "space-between",
              gap: "5px"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.AccordionTitleText, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: labelClose ? shouldBeOpen ? labelClose : label : label
              })
            }), selectedIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CircleBorder, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                src: CheckIconPath
              })
            }) : null]
          })]
        }), children && (shouldBeOpen ? showIconWhenOpen !== false && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.DrawerIcon, {
          $fill: iconColor,
          $marginLeft: marginLeft,
          children: /*#__PURE__*/(0, _react.createElement)(Icons[expandedIcon], {
            "aria-hidden": "true"
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.DrawerIcon, {
          $fill: iconColor,
          $marginLeft: marginLeft,
          children: /*#__PURE__*/(0, _react.createElement)(Icons[collapsedIcon], {
            "aria-hidden": "true"
          })
        }))]
      }), headingContents]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.DrawerContent, {
      id: `${id}-control`,
      $drawerOpen: shouldBeOpen,
      ref: collapseMenuRef,
      children: children
    })]
  });
};
var _default = exports.default = (0, _analytics.withAnalytics)((0, _styledComponentThemes.default)(AccordionDrawer, themes))();